import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "36",
  height: "37"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M35.972 3.576a2.24 2.24 0 0 0-.95-2.194 2.26 2.26 0 0 0-2.39-.098l-31.5 18a2.23 2.23 0 0 0-1.125 2.088 2.26 2.26 0 0 0 1.378 1.94l9.865 4.107v6.54a3.023 3.023 0 0 0 3.023 3.022c.921 0 1.786-.414 2.363-1.132l3.712-4.64h.007l8.03 3.347a2.254 2.254 0 0 0 3.094-1.73l4.5-29.25zM18.182 30.31l-3.304 4.134a.78.78 0 0 1-.605.288.77.77 0 0 1-.773-.773v-5.604l4.683 1.955Zm3.031-1.174L14.421 26.3 33.335 5.94 29.25 32.48l-8.03-3.346h-.007ZM31.676 4.413 12.206 25.38 2.25 21.232l29.426-16.82Z"
    }, null, -1)
  ])))
}
export default { render: render }